/* eslint-disable */
import React, { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import ReactToPrint from 'react-to-print';
import { Button, Col, Form, Row, Table } from 'react-bootstrap';
import axios from 'axios';

import { ContainerTest } from './style';
import CodeCheckComponent from './Components/CodeCheck.component';
import ListeningContainer from './Components/PreTestComponents/Listening/Listening.container';
import ReadingContainer from './Components/PreTestComponents/Reading/Reading.container';
import WritingContainer from './Components/PreTestComponents/Writing/Writing.container';
import { listeningAnswerKey, readingAnswerKey } from './Components/PreTestComponents/AnswerKey';
import AnswerTable from './Components/AnswerTable';
import WritingSampleAnswers, {
  PRE_TEST_WRITING_SAMPLES
} from './Components/WritingSampleAnswers';
import {
  convertListeningScore,
  convertReadingScore,
  sanitizePrintDocumentTitle,
  validateEmail
} from '../../Assets/utils';
import { SecondaryColor, WhiteColor } from '../../Assets/colorPalette';
import { CenterDiv } from '../Home/Contact/Contact.styled';

const PAGE = {
  AUTH: 1,
  LISTENING: 2,
  READING: 3,
  WRITING: 4,
  COUNTING_ANSWER: 5
};

const PreTestContainer = () => {
  const [page, setPage] = useState(PAGE.AUTH);
  const [fillFormPage, setFillFormPage] = useState(true);

  const listeningAnswer = useSelector((state) => state.answer.value);
  const readingAnswer = useSelector((state) => state.answer.readingAnswer);
  const writingAnswer = useSelector((state) => state.answer.writingAnswer);

  const [totalListeningAnswer, setTotalListeningAnswer] = useState(0);
  const [totalReadingAnswer, setTotalReadingAnswer] = useState(0);

  const [listeningAnswerArray, setListeningAnswerArray] = useState([]);
  const [readingAnswerArray, setReadingAnswerArray] = useState([]);

  const [profile, setProfile] = useState({
    name: '',
    email: '',
    phone: ''
  });

  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitError, setSubmitError] = useState('');

  const dispatch = useDispatch();

  const renderAnswerToArray = () => {
    let tempListeningArray = [];
    let tempReadingArray = [];
    for (let i = 1; i <= 40; i++) {
      tempListeningArray.push(listeningAnswer[i]);
      tempReadingArray.push(readingAnswer[i]);
    }
    setListeningAnswerArray(tempListeningArray);
    setReadingAnswerArray(tempReadingArray);
  };

  const handleNextPage = () => {
    setPage(page + 1);
  };

  useEffect(() => {
    renderAnswerToArray();
  }, []);

  const convertAnswer = (answer) => {
    if (Array.isArray(answer)) {
      return answer.map((data, index) => {
        if (index + 1 === answer.length) {
          return `${data}`;
        } else {
          return `${data}, `;
        }
      });
    } else {
      return answer;
    }
  };

  const sendResults = (listening, reading, answer) => {
    const payload = {
      name: profile.name,
      email: profile.email,
      notelp: profile.phone,
      listening,
      reading,
      answer: JSON.stringify(answer),
      firstWriting: writingAnswer[1],
      secondWriting: writingAnswer[2],
      test: 'Pre Test'
    };

    axios
      .post('https://api.inggo.id/inggo', payload)
      .then(() => {
        setFillFormPage(false);
      })
      .catch((e) => {
        console.log(e);
        setSubmitError(
          'We couldn\'t save your results. Please check your internet connection and press "See my results" again. Don\'t close or refresh this page, or your answers will be lost.'
        );
      })
      .finally(() => {
        setIsSubmitting(false);
      });
  };

  const renderTableContent = () => {
    const writingAnswerArray = [writingAnswer[1], writingAnswer[2]];
    return (
      <>
        <Row>
          <Col md={4} sm={4}>
            <b>Listening Score</b>
          </Col>
          <Col md={1} sm={1}>
            :
          </Col>
          <Col>{convertListeningScore(totalListeningAnswer)}</Col>
        </Row>
        <Row className="mt-2">
          <Col md={4} sm={4}>
            <b>Reading Score</b>
          </Col>
          <Col md={1} sm={1}>
            :
          </Col>
          <Col>{convertReadingScore(totalReadingAnswer)}</Col>
        </Row>
        <hr />
        <AnswerTable
          listeningAnswer={listeningAnswer}
          listeningAnswerKey={listeningAnswerKey}
          readingAnswer={readingAnswer}
          readingAnswerKey={readingAnswerKey}
          writingAnswer={writingAnswerArray}
        />
        <hr className="mt-4" />
        <WritingSampleAnswers samples={PRE_TEST_WRITING_SAMPLES} />
      </>
    );
  };

  const ComponentToPrint = React.forwardRef((props, ref) => {
    return (
      <div ref={ref} className="p-5">
        <h4 className="text-center">
          <b>{profile.name} (Pre Test)</b>
        </h4>
        {renderTableContent()}
      </div>
    );
  });

  const componentRef = useRef();

  const checkingAnswer = () => {
    let listeningAnswerTemp = 0;
    let readingAnswerTemp = 0;

    for (let i = 1; i <= 40; i++) {
      const listeningRaw = listeningAnswer[i];
      if (listeningRaw !== '' && listeningRaw !== undefined && listeningRaw !== null) {
        // Q14–15 are one multi-select: score only on Q14. Do NOT continue the loop
        // or Reading Q15 is skipped.
        if (i === 14) {
          let temp = '';
          for (let a = 0; a < listeningRaw.length; a++) {
            const choice = String(listeningRaw[a]).trim().toLowerCase();
            if (listeningAnswerKey[i].includes(choice) && temp !== choice) {
              temp = choice;
              listeningAnswerTemp += 1;
            }
          }
        } else if (i === 15) {
          // skip duplicate listening multi slots only
        } else if (Array.isArray(listeningAnswerKey[i])) {
          const ans = String(listeningRaw).trim().toLowerCase();
          if (ans !== '') {
            for (let j = 0; j < listeningAnswerKey[i].length; j++) {
              if (listeningAnswerKey[i][j].toLowerCase().includes(ans)) {
                listeningAnswerTemp += 1;
                break;
              }
            }
          }
        } else {
          const ans = String(listeningRaw).trim().toLowerCase();
          if (ans !== '' && ans === listeningAnswerKey[i].toLowerCase()) {
            listeningAnswerTemp += 1;
          }
        }
      }

      const readingRaw = readingAnswer[i];
      if (readingRaw !== '' && readingRaw !== undefined && readingRaw !== null) {
        if (i === 6 || i === 7) {
          const ans = String(readingRaw).trim().toLowerCase();
          const matchesKey =
            ans === readingAnswerKey[i][0].toLowerCase() ||
            ans === readingAnswerKey[i][1].toLowerCase();
          if (matchesKey) {
            const prev = String(readingAnswer[i - 1] || '')
              .trim()
              .toLowerCase();
            if (!(i === 7 && ans === prev)) {
              readingAnswerTemp += 1;
            }
          }
        } else if (Array.isArray(readingAnswerKey[i])) {
          const ans = String(readingRaw).trim().toLowerCase();
          if (ans !== '') {
            for (let k = 0; k < readingAnswerKey[i].length; k++) {
              if (readingAnswerKey[i][k].toLowerCase().includes(ans)) {
                readingAnswerTemp += 1;
                break;
              }
            }
          }
        } else {
          const ans = String(readingRaw).trim().toLowerCase();
          if (ans !== '' && ans === readingAnswerKey[i].toLowerCase()) {
            readingAnswerTemp += 1;
          }
        }
      }
    }

    setTotalReadingAnswer(readingAnswerTemp);
    setTotalListeningAnswer(listeningAnswerTemp);

    sendResults(
      convertListeningScore(listeningAnswerTemp),
      convertReadingScore(readingAnswerTemp),
      {
        listeningAnswer,
        readingAnswer
      }
    );
  };

  return (
    <ContainerTest>
      {page === PAGE.AUTH && (
        <CodeCheckComponent handleNextPage={handleNextPage} dispatch={dispatch} />
      )}
      {page === PAGE.LISTENING && (
        <ListeningContainer handleNextPage={handleNextPage} dispatch={dispatch} />
      )}
      {page === PAGE.READING && (
        <ReadingContainer handleNextPage={handleNextPage} dispatch={dispatch} />
      )}
      {page === PAGE.WRITING && (
        <WritingContainer handleNextPage={handleNextPage} dispatch={dispatch} />
      )}
      {page === PAGE.COUNTING_ANSWER && (
        <>
          <div style={{ display: 'none' }}>
            <ComponentToPrint ref={componentRef} />
          </div>

          {fillFormPage && (
            <Row className="p-4">
              <Col md={6} className="mx-auto">
                <Form>
                  <Form.Group className="mb-3" controlId="formBasicName">
                    <Form.Label>Name</Form.Label>
                    <Form.Control
                      type="text"
                      placeholder="Enter name"
                      onChange={(e) => {
                        setProfile({
                          ...profile,
                          name: e.target.value
                        });
                      }}
                    />
                  </Form.Group>
                  <Form.Group className="mb-3" controlId="formBasicEmail">
                    <Form.Label>Email address</Form.Label>
                    <Form.Control
                      type="email"
                      placeholder="Enter email"
                      onChange={(e) => {
                        setProfile({
                          ...profile,
                          email: e.target.value
                        });
                      }}
                    />
                    <Form.Text className="text-muted">
                      Make sure you enter correct email format
                    </Form.Text>
                  </Form.Group>
                  <Form.Group className="mb-3" controlId="formBasicPhone">
                    <Form.Label>Phone number</Form.Label>
                    <Form.Control
                      type="text"
                      placeholder="Enter phone number"
                      onChange={(e) => {
                        setProfile({
                          ...profile,
                          phone: e.target.value
                        });
                      }}
                    />
                  </Form.Group>
                  <CenterDiv>
                    <Button
                      style={{
                        backgroundColor: SecondaryColor,
                        color: WhiteColor,
                        border: 'none',
                        borderRadius: '100px',
                        padding: '11px 42px'
                      }}
                      disabled={
                        profile.name === '' ||
                        profile.phone === '' ||
                        profile.email === '' ||
                        !validateEmail(profile.email) ||
                        isSubmitting
                      }
                      onClick={() => {
                        setSubmitError('');
                        setIsSubmitting(true);
                        checkingAnswer();
                      }}>
                      {isSubmitting ? 'Processing...' : 'See my results'}
                    </Button>
                  </CenterDiv>
                  {submitError && (
                    <Form.Text className="text-danger d-block text-center mt-3">
                      {submitError}
                    </Form.Text>
                  )}
                </Form>
              </Col>
            </Row>
          )}

          {!fillFormPage && (
            <>
              <div className="p-5">
                <h4 className="text-center">
                  <b>{profile.name} (Pre Test)</b>
                </h4>
                {renderTableContent()}
              </div>
              <Row>
                <Col md={4} className="mx-auto mb-4">
                  <ReactToPrint
                    trigger={() => (
                      <button
                        style={{
                          backgroundColor: SecondaryColor,
                          color: WhiteColor,
                          border: 'none',
                          borderRadius: '100px',
                          padding: '11px 42px'
                        }}
                        onClick={() => checkingAnswer()}>
                        Download Answer Sheet and Answer Key
                      </button>
                    )}
                    content={() => componentRef.current}
                    documentTitle={sanitizePrintDocumentTitle(profile.name, 'Pre Test')}
                  />
                </Col>
              </Row>
            </>
          )}
        </>
      )}
    </ContainerTest>
  );
};

export default PreTestContainer;
